import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FloatingButtonComponent} from './floating-button.component';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {defineElement} from "lord-icon-element";
import lottie from "lottie-web";
import {ExtendedModule, FlexLayoutModule} from "@ngbracket/ngx-layout";
import {RouterModule} from "@angular/router";

@NgModule({
  declarations: [
    FloatingButtonComponent
  ],
  exports: [
    FloatingButtonComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    ExtendedModule,
    RouterModule,
    FlexLayoutModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FloatingButtonModule {
  constructor() {
    defineElement(lottie.loadAnimation);
  }
}
